import React, { useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import {useTranslation} from "react-i18next";
import styles from "./Tags.module.css";
import branchApi from "../../../../store/branchStore/branchApi";
import {BadgeTag} from "../../../../components/Badge";

export default function Tags() {
    const {info} = useSelector(state => state.branchReducer)
    const [fetching, setFetching] = useState(false);
    const [tags, setTags] = useState([]);
    const { t } = useTranslation();

    const getTags = async (branchId) => {
        try {
            setFetching(true)
            branchApi
              .getAnalyticTags(branchId)
              .then(res => setTags(res?.data?.tags || []))
        } finally {
            setFetching(false)
        }
    }

    useEffect(() => {
        if (info) {
            getTags(info.id)
        }
    }, [info?.id])


    return (
      <div className={styles.container}>
          <h1>{t('NSTag.tags')}</h1>

          <table className={`table ${fetching ? 'loading' : ''}`}>
              <thead>
              <tr>
                  <th></th>
                  <th>
                      {t('NSGeneral.clients')}
                  </th>
                  <th>{t('NSGeneral.sales')}</th>
                  <th>{t('NSLoyal.transactions')}</th>
                  <th>{t('NSGeneral.average')}</th>
                  <th>{t('NSGeneral.bonuses')}</th>
                  <th>{t('NSGeneral.used')}</th>
              </tr>
              </thead>
              <tbody>
              {tags.length ? tags.map(tag => (
                <tr key={tag.id}>
                    <td>
                        <BadgeTag style={{ background: tag.background_color, color: tag.color }}>{tag.title}</BadgeTag>
                    </td>
                    <td>{tag.client_count}</td>
                    <td>{tag.total_purchases}</td>
                    <td>{tag.transaction_count}</td>
                    <td>{tag.average_order_value}</td>
                    <td>{tag.earned_bonuses}</td>
                    <td>{tag.spent_bonuses}</td>
                </tr>
              )) : (
                <tr>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
              )}
              </tbody>
          </table>
      </div>
    )
}
